import { Api } from 'further-types/further-user';

export enum FirmAccountResolutionKind {
  Idle = 'idle',
  Ok = 'ok',
  NeedsChooseAccount = 'needs_choose_account',
  AutoSwitch = 'auto_switch',
}

export type FirmAccountResolution =
  | { kind: FirmAccountResolutionKind.Idle }
  | { kind: FirmAccountResolutionKind.Ok }
  | { kind: FirmAccountResolutionKind.NeedsChooseAccount }
  | { kind: FirmAccountResolutionKind.AutoSwitch; accountId: string };

export function resolveFirmAccountResolution(input: {
  enabled: boolean;
  activeAccountId?: string;
  accounts?: Api.ListAccountsToAccessResponse;
}): FirmAccountResolution {
  const { enabled, activeAccountId, accounts } = input;

  if (!enabled || !activeAccountId || !accounts) {
    return { kind: FirmAccountResolutionKind.Idle };
  }

  const isValidForFirm = accounts.investors.some(
    (inv) => inv._id === activeAccountId,
  );

  if (isValidForFirm) {
    return { kind: FirmAccountResolutionKind.Ok };
  }

  const hasOnlyOneInvestorAccount =
    accounts.investors.length === 1 && !accounts.adviser && !accounts.orgUser;

  if (hasOnlyOneInvestorAccount) {
    return {
      kind: FirmAccountResolutionKind.AutoSwitch,
      accountId: accounts.investors[0]._id,
    };
  }

  // Active account is not valid for the firm and there is only one investor
  // account, so return needs_choose_account:
  return { kind: FirmAccountResolutionKind.NeedsChooseAccount };
}
